import React, { useCallback, useEffect, useState } from "react";

import Navbar from "./clientHom/Navbar";
import Footer from "./uniComponents/AndUsFooter";
import TalentLenzVideoHero from "./talentLenz/TalentLenzVideoHero";
import TalentLenzProductNavigation from "./talentLenz/TalentLenzProductNavigation";
import TalentLenzApplicationVolumeProblem from "./talentLenz/TalentLenzApplicationVolumeProblem";
import TalentLenzAccessModels from "./talentLenz/TalentLenzAccessModels";
import TalentLenzAssessmentBuilder from "./talentLenz/TalentLenzAssessmentBuilder";
import TalentLenzOpportunityDefinition from "./talentLenz/TalentLenzOpportunityDefinition";
import TalentLenzApplicantEvidenceJourney from "./talentLenz/TalentLenzApplicantEvidenceJourney";
import TalentLenzOpportunitySpecificSuitability from "./talentLenz/TalentLenzOpportunitySpecificSuitability";
import TalentLenzOpportunityUseCases from "./talentLenz/TalentLenzOpportunityUseCases";
import TalentLenzResponsibleSelection from "./talentLenz/TalentLenzResponsibleSelection";
import TalentLenzRankedShortlist from "./talentLenz/TalentLenzRankedShortlist";
import TalentLenzFinalConversionCTA from "./talentLenz/TalentLenzFinalConversionCTA";
import BrochureRequestModal from "./clientHom/BrochureRequestModal";

import "./TalentLenzPage.css";

export default function TalentLenzPage() {
  const [brochureModalOpen, setBrochureModalOpen] = useState(false);
  const closeBrochureModal = useCallback(() => setBrochureModalOpen(false), []);
  useEffect(() => {
    const previousTitle = document.title;

    document.title = "TalentLenz | AndUs";
    window.scrollTo(0, 0);

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="talent-lenz-public-page">
      <Navbar />

      <main className="talent-lenz-public-page__main">
        <TalentLenzVideoHero />
        <TalentLenzProductNavigation />
        <TalentLenzApplicationVolumeProblem />
        <TalentLenzOpportunityDefinition />
        <TalentLenzAccessModels />
        <TalentLenzAssessmentBuilder />
        <TalentLenzApplicantEvidenceJourney />
        <TalentLenzOpportunitySpecificSuitability />
        <TalentLenzRankedShortlist /> 
        <TalentLenzResponsibleSelection />
        <TalentLenzOpportunityUseCases />
        <TalentLenzFinalConversionCTA
          onBrochureClick={() => setBrochureModalOpen(true)}
        />
        <div
          id="talentlenz-page-content"
          className="talent-lenz-public-page__development-anchor"
          aria-hidden="true"
        />
      </main>

      <Footer />
      <BrochureRequestModal
        open={brochureModalOpen}
        onClose={closeBrochureModal}
        productName="TalentLenz"
        brochures={[
          {
            file: "AndUs_TalentLenz_Product_Brochure_2026.pdf",
            title: "TalentLenz Product Brochure 2026",
          },
        ]}
      />
    </div>
  );
}
